import {ILeadModalLeadType} from "../../application/types/lead/ILeadModalLeadType";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmStepApplicationClose = (_leadType: ILeadModalLeadType) => {
    hitGoogleTagManager({event: "step_form_close", event_category: "standard"});

    return true;
};
